import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function SortableTableRow({ id, children }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  return (
    <tr
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        background: isDragging ? '#fef9ee' : undefined,
      }}
    >
      <td
        className="px-3 py-3 text-gray-300 hover:text-gray-500 cursor-grab active:cursor-grabbing"
        {...attributes}
        {...listeners}
        title="Drag to reorder"
      >
        ⠿
      </td>
      {children}
    </tr>
  );
}
